<!-- Start::Header -->
@if (authenticated) {
<header class="app-header">
  <nav class="main-header" aria-label="Global">
    <div class="main-header-container">

      <div class="header-content-left">
        <!-- Start::header-element -->
        <div class="header-element">
          <div class="horizontal-logo">
            <a routerLink="/" class="header-logo">
              <img src="./assets/images/logofinapay1.png" alt="logo" class="desktop-logo !h-[3rem]">
              <img src="./assets/images/ico-logo-welloo-01.png" alt="logo" class="toggle-logo">
              <img src="./assets/images/logofinapay1.png" alt="logo" class="desktop-dark !h-[3rem]">
              <img src="./assets/images/ico-logo-welloo-01.png" alt="logo" class="toggle-dark ">
              <img src="./assets/images/logofinapay1.png" alt="logo" class="desktop-white !h-[3rem]">
              <img src="./assets/images/ico-logo-welloo-01.png" alt="logo" class="toggle-white">
            </a>
          </div>
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element !items-center">
          <!-- Start::header-link -->
          <a aria-label="Hide Sidebar" (click)="toggleSidebar()"
            class="sidemenu-toggle animated-arrow  hor-toggle horizontal-navtoggle inline-flex items-center"
            href="javascript:void(0);"><span></span></a>
          <!-- End::header-link -->
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element header-search md:!block !hidden my-auto relative">
          <!-- Start::header-link -->
          <!-- <input type="text" class="header-search-bar form-control" id="header-search"
                  placeholder="Search for Results..." spellcheck=false autocomplete="off" autocapitalize="off">
                <a href="javascript:void(0);" class="header-search-icon border-0">
                  <i class="bi bi-search"></i>
                </a> -->
          <input type="text" class="header-search-bar form-control" id="header-search" placeholder="rechercher..."
            spellcheck=false autocomplete="off" autocapitalize="off" (click)="SearchHeader()" [(ngModel)]="text"
            [ngModelOptions]="{ standalone: true }" (keyup)="Search(text)">
          <a href="javascript:void(0);" class="header-search-icon border-0">
            <i class="bi bi-search"></i>
          </a>
          <!-- End::header-link -->
          @if(menuItems && menuItems.length > 0){

          <div class="search_drop list-group" (click)="clearSearch()">
            @for(menuItem of menuItems | slice:0:5;track $index){

            <div class="list-group-item" [routerLink]="menuItem?.path" (click)="clearSearch()">
              <a [routerLink]="menuItem?.path"><span><i
                    class='fa fa-angle-double-right me-2 rtl-transform-icon'></i>{{menuItem?.title}}</span></a>
            </div>

            }
          </div>

          }
          @else{
          <ng-template>
            <ul class="ps-2">
              <li class="p-1 flex align-items-center text-textmuted mb-2 search-app">
                <a><span><i class='fa fa-angle-double-right me-2'></i>pas de résultat pour "{{text}}"</span></a>
              </li>

            </ul>
          </ng-template>
          }
          <!-- End::header-link -->
        </div>
        <!-- End::header-element -->

      </div>

      <div class="header-content-right">

        <div class="header-element md:px-[0.5rem] px-1 header-search md:!hidden !block">
          <button aria-label="button" type="button" data-hs-overlay="#search-modal"
            class="inline-flex flex-shrink-0 justify-center items-center gap-2  rounded-full font-medium focus:ring-offset-0 focus:ring-offset-white transition-all text-xs dark:bg-bgdark dark:hover:bg-black/20 text-textmuted dark:text-textmuted/50 dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10">
            <i class="bi bi-search header-link-icon leading-none"></i>
          </button>
        </div>

        <!-- light and dark theme -->
        <div class="header-element header-theme-mode hidden !items-center sm:block md:!px-[0.5rem] px-2">
          <a aria-label="anchor" (click)="updateTheme('dark')"
            class="hs-dark-mode-active:hidden flex hs-dark-mode group flex-shrink-0 justify-center items-center gap-2  rounded-full font-medium transition-all text-xs dark:bg-bgdark dark:hover:bg-black/20 text-textmuted dark:text-textmuted/50 dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
            href="javascript:void(0);" data-hs-theme-click-value="dark">
            <svg xmlns="http://www.w3.org/2000/svg" class="header-link-icon" width="32" height="32" fill="#000000"
              viewBox="0 0 256 256">
              <path
                d="M98.31,130.38ZM94.38,17.62h0A64.06,64.06,0,0,1,17.62,94.38h0A64.12,64.12,0,0,0,55,138.93h0a44.08,44.08,0,0,1,43.33-8.54,68.13,68.13,0,0,1,45.47-47.32l.15,0c0-1,.07-2,.07-3A64,64,0,0,0,94.38,17.62Z"
                opacity="0.1"></path>
              <path
                d="M164,72a76.45,76.45,0,0,0-12.36,1A71.93,71.93,0,0,0,96.17,9.83a8,8,0,0,0-9.59,9.58A56.45,56.45,0,0,1,88,32,56.06,56.06,0,0,1,32,88a56.45,56.45,0,0,1-12.59-1.42,8,8,0,0,0-9.59,9.59,72.22,72.22,0,0,0,32.29,45.06A52,52,0,0,0,84,224h80a76,76,0,0,0,0-152ZM29.37,104c.87,0,1.75,0,2.63,0a72.08,72.08,0,0,0,72-72c0-.89,0-1.78,0-2.67a55.63,55.63,0,0,1,32,48,76.28,76.28,0,0,0-43,43.4A52,52,0,0,0,54,129.59,56.22,56.22,0,0,1,29.37,104ZM164,208H84a36,36,0,1,1,4.78-71.69c-.37,2.37-.63,4.79-.77,7.23a8,8,0,0,0,16,.92,58.91,58.91,0,0,1,1.88-11.81c0-.16.09-.32.12-.48A60.06,60.06,0,1,1,164,208Z">
              </path>
            </svg>
          </a>
          <a aria-label="anchor" (click)="updateTheme('light')"
            class="hs-dark-mode-active:flex hidden hs-dark-mode group flex-shrink-0 justify-center items-center gap-2  rounded-full font-medium text-defaulttextcolor  transition-all text-xs dark:bg-bodybg dark:bg-bgdark dark:hover:bg-black/20  dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
            href="javascript:void(0);" data-hs-theme-click-value="light">
            <svg xmlns="http://www.w3.org/2000/svg" class="header-link-icon" width="32" height="32" fill="#000000"
              viewBox="0 0 256 256">
              <path
                d="M131.84,84.41v0a68.22,68.22,0,0,0-41.65,46v-.11a44.08,44.08,0,0,0-38.54,5h0a48,48,0,1,1,80.19-50.94Z"
                opacity="0.1"></path>
              <path
                d="M156,72a76.2,76.2,0,0,0-20.26,2.73,55.63,55.63,0,0,0-9.41-11.54l9.51-13.57a8,8,0,1,0-13.11-9.18L113.22,54A55.9,55.9,0,0,0,88,48c-.58,0-1.16,0-1.74,0L83.37,31.71a8,8,0,1,0-15.75,2.77L70.5,50.82A56.1,56.1,0,0,0,47.23,65.67L33.61,56.14a8,8,0,1,0-9.17,13.11L38,78.77A55.55,55.55,0,0,0,32,104c0,.57,0,1.15,0,1.72L15.71,108.6a8,8,0,0,0,1.38,15.88,8.24,8.24,0,0,0,1.39-.12l16.32-2.88a55.74,55.74,0,0,0,5.86,12.42A52,52,0,0,0,76,224h80a76,76,0,0,0,0-152ZM48,104a40,40,0,0,1,72.54-23.24,76.26,76.26,0,0,0-35.62,40,52.14,52.14,0,0,0-31,4.17A40,40,0,0,1,48,104ZM156,208H76a36,36,0,1,1,4.78-71.69c-.37,2.37-.63,4.79-.77,7.23a8,8,0,0,0,16,.92,58.91,58.91,0,0,1,1.88-11.81c0-.16.09-.32.12-.48A60.06,60.06,0,1,1,156,208Z">
              </path>
            </svg>
          </a>
        </div>
        <!-- End light and dark theme -->

        <!-- Fullscreen -->
        <div class="header-element header-fullscreen  md:px-[0.5rem] px-1">
          <!-- Start::header-link -->
          <a aria-label="anchor" (click)="toggleFullscreen()" href="javascript:void(0);"
            class="inline-flex flex-shrink-0 justify-center items-center gap-2  !rounded-full font-medium dark:hover:bg-black/20 text-textmuted dark:text-textmuted/50 dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10">
            <svg xmlns="http://www.w3.org/2000/svg" [ngClass]="{ 'hidden': isFullscreen }"
              class="full-screen-open header-link-icon" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
              <path d="M208,48V88L168,48ZM48,208H88L48,168Zm160,0V168l-40,40ZM48,88,88,48H48Z" opacity="0.1">
              </path>
              <path
                d="M208,40H168a8,8,0,0,0-5.66,13.66l40,40A8,8,0,0,0,216,88V48A8,8,0,0,0,208,40Zm-8,28.69L187.31,56H200ZM53.66,162.34A8,8,0,0,0,40,168v40a8,8,0,0,0,8,8H88a8,8,0,0,0,5.66-13.66ZM56,200V187.31L68.69,200Zm155.06-39.39a8,8,0,0,0-8.72,1.73l-40,40A8,8,0,0,0,168,216h40a8,8,0,0,0,8-8V168A8,8,0,0,0,211.06,160.61ZM200,200H187.31L200,187.31ZM88,40H48a8,8,0,0,0-8,8V88a8,8,0,0,0,13.66,5.66l40-40A8,8,0,0,0,88,40ZM56,68.69V56H68.69Z">
              </path>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" class="full-screen-close header-link-icon hidden"
              [ngClass]="{ 'hidden': !isFullscreen }" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
              <path d="M208,48V96L160,48ZM48,208H96L48,160Z" opacity="0.1"></path>
              <path
                d="M208,40H160a8,8,0,0,0-5.66,13.66L172.69,72l-34.35,34.34a8,8,0,0,0,11.32,11.32L184,83.31l18.34,18.35A8,8,0,0,0,216,96V48A8,8,0,0,0,208,40Zm-8,36.69L179.31,56H200Zm-93.66,61.65L72,172.69,53.66,154.34A8,8,0,0,0,40,160v48a8,8,0,0,0,8,8H96a8,8,0,0,0,5.66-13.66L83.31,184l34.35-34.34a8,8,0,0,0-11.32-11.32ZM56,200V179.31L76.69,200Z">
              </path>
            </svg>
          </a>
          <!-- End::header-link -->
        </div>
        <!-- End Full screen -->

        <!-- Header Profile -->
        <div
          class="header-element md:!px-[0.5rem] px-2 ti-dropdown hs-dropdown !items-center [--placement:bottom-right] rtl:[--placement:bottom-left]">

          <button id="dropdown-profile" type="button"
            class="hs-dropdown-toggle ti-dropdown-toggle !gap-2 !p-0 flex-shrink-0 sm:me-2 me-0 !rounded-full !shadow-none text-xs align-middle !border-0 !shadow-transparent ">
            <img class="avatar avatar-sm avatar-rounded inline-block"
              [src]="user?.photo || './assets/images/user_default.png'" alt="Image Description">
          </button>

          <div class="xl:block hidden dropdown-profile">
            <span class="font-medium leading-none">{{user?.name}}</span>
          </div>

          <ul
            class="main-header-dropdown ti-dropdown-menu hs-dropdown-menu !w-[11rem] hidden pt-0 overflow-hidden header-profile-dropdown">
            <li><a
                class="ti-dropdown-item !py-[0.6rem] !px-4 !border-b flex items-center  dark:!border-defaultborder/10"
                routerLink="/comptes/profil"><i class="ti ti-user me-2 text-[1.125rem] text-primary"></i>Profil</a></li>
            <li><a
                class="ti-dropdown-item !py-[0.6rem] !px-4 !border-b flex items-center  dark:!border-defaultborder/10"
                routerLink="/transactions"><i
                  class="ti ti-checklist me-2 text-[1.125rem] text-success"></i>Transactions</a>
            </li>
            <li><a
                class="ti-dropdown-item !py-[0.6rem] !px-4 !border-b flex items-center  dark:!border-defaultborder/10"
                routerLink="/parametres"><i
                  class="ti ti-settings me-2 text-[1.125rem] text-orangemain"></i>Paramètres</a>
            </li>
            <li><a class="ti-dropdown-item !py-[0.6rem] !px-4 flex items-center" (click)="logout()"><i
                  class="ti ti-logout me-2 text-[1.125rem] text-warning" href="javascript:void(0);"></i>
                Me déconnecter</a>
            </li>
          </ul>
        </div>
        <!-- End Header Profile -->

        <!-- Switcher Icon -->
        <!-- <div class="header-element md:px-[0.48rem]">
          <button aria-label="button" type="button"
            class="hs-dropdown-toggle switcher-icon inline-flex flex-shrink-0 justify-center items-center gap-2  rounded-full font-medium  align-middle transition-all text-xs text-textmuted dark:text-textmuted/50 dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
            data-hs-overlay="#hs-overlay-switcher">
            <svg xmlns="http://www.w3.org/2000/svg" class="header-link-icon animate-spin-slow" width="32" height="32"
              fill="#000000" viewBox="0 0 256 256">
              <path
                d="M230.1,108.76,198.25,90.62c-.64-1.16-1.31-2.29-2-3.41l-.12-36A104.61,104.61,0,0,0,162,32L130,49.89c-1.34,0-2.69,0-4,0L94,32A104.58,104.58,0,0,0,59.89,51.25l-.16,36c-.7,1.12-1.37,2.26-2,3.41l-31.84,18.1a99.15,99.15,0,0,0,0,38.46l31.85,18.14c.64,1.16,1.31,2.29,2,3.41l.12,36A104.61,104.61,0,0,0,94,224l32-17.87c1.34,0,2.69,0,4,0L162,224a104.58,104.58,0,0,0,34.08-19.25l.16-36c.7-1.12,1.37-2.26,2-3.41l31.84-18.1A99.15,99.15,0,0,0,230.1,108.76ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z"
                opacity="0.1"></path>
              <path
                d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm109.94-52.79a8,8,0,0,0-3.89-5.4l-29.83-17-.12-33.62a8,8,0,0,0-2.83-6.08,111.91,111.91,0,0,0-36.72-20.67,8,8,0,0,0-6.46.59L128,41.85,97.88,25a8,8,0,0,0-6.47-.6A111.92,111.92,0,0,0,54.73,45.15a8,8,0,0,0-2.83,6.07l-.15,33.65-29.83,17a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,0,0,41.56,8,8,0,0,0,3.89,5.4l29.83,17,.12,33.63a8,8,0,0,0,2.83,6.08,111.91,111.91,0,0,0,36.72,20.67,8,8,0,0,0,6.46-.59L128,214.15,158.12,231a7.91,7.91,0,0,0,3.9,1,8.09,8.09,0,0,0,2.57-.42,112.1,112.1,0,0,0,36.68-20.73,8,8,0,0,0,2.83-6.07l.15-33.65,29.83-17a8,8,0,0,0,3.89-5.4A106.47,106.47,0,0,0,237.94,107.21Zm-15,34.91-28.57,16.25a8,8,0,0,0-3,3c-.58,1-1.19,2.06-1.81,3.06a7.94,7.94,0,0,0-1.22,4.21l-.15,32.25a95.89,95.89,0,0,1-25.37,14.3L134,199.13a8,8,0,0,0-3.91-1h-.19c-1.21,0-2.43,0-3.64,0a8.1,8.1,0,0,0-4.1,1l-28.84,16.1A96,96,0,0,1,67.88,201l-.11-32.2a8,8,0,0,0-1.22-4.22c-.62-1-1.23-2-1.8-3.06a8.09,8.09,0,0,0-3-3.06l-28.6-16.29a90.49,90.49,0,0,1,0-28.26L61.67,97.63a8,8,0,0,0,3-3c.58-1,1.19-2.06,1.81-3.06a7.94,7.94,0,0,0,1.22-4.21l.15-32.25a95.89,95.89,0,0,1,25.37-14.3L122,56.87a8,8,0,0,0,4.1,1c1.21,0,2.43,0,3.64,0a8,8,0,0,0,4.1-1l28.84-16.1A96,96,0,0,1,188.12,55l.11,32.2a8,8,0,0,0,1.22,4.22c.62,1,1.23,2,1.8,3.06a8.09,8.09,0,0,0,3,3.06l28.6,16.29A90.49,90.49,0,0,1,222.9,142.12Z">
              </path>
            </svg>
          </button>
        </div> -->
        <!-- Switcher Icon -->

        <!-- End::header-element -->
      </div>
    </div>
  </nav>
</header>
}
<!-- End::Header -->

<!-- ========== Search Modal ========== -->
<div id="search-modal" class="hs-overlay ti-modal hidden mt-[1.75rem]">
  <div class="ti-modal-box">
    <div class="ti-modal-content !border !border-defaultborder dark:!border-defaultborder/10 !rounded-[0.5rem]">
      <div class="ti-modal-body">

        <div class="input-group">
          <input type="text" class="form-control !border-s border-e-0" placeholder="Search Anything ..."
            aria-label="Search Anything ..." aria-describedby="button-addon2">

          <button class="ti-btn ti-btn-primary !m-0" type="button" id="button-addon2"><i
              class="bi bi-search"></i></button>

        </div>
      </div>

    </div>
  </div>
</div>
<!-- ========== END Search Modal ========== -->